import PropTypes from 'prop-types';

import { ToneOfVoiceList } from 'src/components/ToneOfVoiceList';
import { GENERATION_IMPROVE_MODE } from 'src/data/generation';

import { InternalSubmenuListItem } from '../InternalSubmenuListItem';

const propTypes = {
  className: PropTypes.string,
  ToneOfVoiceListProps: PropTypes.shape(ToneOfVoiceList.propTypes).isRequired,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
};

const defaultProps = {
  className: '',
  selected: false,
  disabled: false,
};

export const ChangeTovListItem = ({ className, ToneOfVoiceListProps, selected, disabled }) => {
  return (
    <InternalSubmenuListItem
      className={className}
      improveMode={GENERATION_IMPROVE_MODE.changeTov}
      selected={selected}
      disabled={disabled}
    >
      {({ closeMenu }) => (
        <ToneOfVoiceList
          {...ToneOfVoiceListProps}
          onSelect={(item) => {
            closeMenu();
            ToneOfVoiceListProps.onSelect(item);
          }}
        />
      )}
    </InternalSubmenuListItem>
  );
};

ChangeTovListItem.displayName = 'ChangeTovListItem';
ChangeTovListItem.propTypes = propTypes;
ChangeTovListItem.defaultProps = defaultProps;
